import { Box, css } from '@mui/material'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const CheckIconWrapper = styled('div')<{ $isSmall: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ $isSmall }: { $isSmall: boolean }) => ($isSmall ? '18px' : '35px')};
  height: ${({ $isSmall }: { $isSmall: boolean }) => ($isSmall ? '18px' : '35px')};
  border-radius: 50%;
  border: 1px solid #c1c1c1;

  svg {
    width: ${({ $isSmall }: { $isSmall: boolean }) => ($isSmall ? '14px' : '1em')};
    height: ${({ $isSmall }: { $isSmall: boolean }) => ($isSmall ? '14px' : '1em')};
  }
  &:hover {
    & .check-mark {
      color: ${colors.primary} !important;
    }
  }
`

export const UpdateTableRowContainer = styled(Box)`
  display: grid;
  grid-template-columns: 3fr 5fr 2fr 1fr;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border-top: 1px solid ${colors.lightGrey};
  ${(props: { isDisabled: boolean }) =>
    props.isDisabled
      ? css`
          opacity: 0.5;
          background-color: #ebebeb;
        `
      : css`
          opacity: 1;
        `}
  &:hover {
    opacity: 1;
    background-color: #f5f5f5;
    & .check-mark {
      color: ${colors.primary} !important;
    }
  }
`

export const UpdateTableHeaderRowContainer = styled(Box)`
  display: grid;
  grid-template-columns: 3fr 5fr 2fr 1fr;
  width: 100%;
`
